import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=49bbf1c6&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49bbf1c6')) {
      api.createRecord('49bbf1c6', component.options)
    } else {
      api.reload('49bbf1c6', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=49bbf1c6&", function () {
      api.rerender('49bbf1c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2BoBMEha5c6wo/JS/comp/openstreetmap.vue"
export default component.exports